/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

const ChevronRightIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      className={props.className}
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
      data-palette="ChevronRightIcon">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Header-1024px-part-1"
          transform="translate(-658.000000, -16.000000)"
          fillRule="nonzero"
        >
          <g id="Group-10-Copy" transform="translate(658.000000, 16.000000)">
            <circle
              id="Oval-5"
              fill="var(--main-bg-surface-alt)"
              cx="10"
              cy="10"
              r="10"
            />
            <g
              id="chevron-right"
              transform="translate(7.500000, 5.000000)"
              fill={props.color || 'var(--main-text-primary)'}
            >
              <g id="Group">
                <g id="Shape">
                  <path
                    d="M6.75538421,7.97887862 C7.04827742,8.2778738 7.52315115,8.2778738 7.81604436,7.97887862 C8.1089376,7.67988347 8.1089376,7.19511653 7.81604436,6.89612138 L3.53033008,2.52112138 C3.23743686,2.2221262 2.76256314,2.2221262 2.46966992,2.52112138 L-1.81604436,6.89612138 C-2.1089376,7.19511653 -2.1089376,7.67988347 -1.81604436,7.97887862 C-1.52315115,8.2778738 -1.04827742,8.2778738 -0.755384207,7.97887862 L3.00205119,4.14316332 L6.75538421,7.97887862 Z"
                    transform="translate(3.000000, 5.250000) rotate(90.000000) translate(-3.000000, -5.250000) "
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default ChevronRightIcon;
